import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function parallaxImages(target) {

    let images = document.querySelectorAll(target);

    images.forEach(image => {

        let wrap = image.closest(".parallax-wrap")

        gsap.to(image, {
            scrollTrigger: {
                trigger: wrap,
                scrub: 0.5,
                invalidateOnRefresh: true
            },
            y: wrap.offsetHeight - image.offsetHeight,
            ease: "none"
        });

    });
}

parallaxImages(".parallax-image")